import styled from "styled-components";
import { Link } from 'react-router-dom';
import warning from '../../img/Warning.svg';

export const Container = styled.section`
    display: flex;
    width: 100%;
    padding: 26px 18px;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
`;

export const Paragraph = styled.p`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0.36px;
    color: rgba(0, 0, 0, 0.85);
    background: url(${warning}) no-repeat 0 0;
    padding-left: 40px;
`;

export const LinkStyled = styled(Link)`
    display: flex;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    background: #5768FF;
    color: #fff;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.42px;

    &:hover {
        background: #5768FF;
        color: #fff;
    }
`;